import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import Styles from "./Search.module.scss";
import SearchField from "analytics-ui/SearchField";

export default class Search extends PureComponent {
  static propTypes = {
    searchValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  onChange = (event) => {
    const { onChange } = this.props;
    if (event) {
      onChange(event.target.value);
    } else {
      onChange("");
    }
  };

  render() {
    const { searchValue } = this.props;

    return (
      <div className={Styles["search"]}>
        <SearchField
          data-testid="AnalticsSpa-ListControlPanel-ListSearchField"
          placeholder="Search"
          onChange={this.onChange}
          value={searchValue}
        />
      </div>
    );
  }
}
